export const warehouse = {
  'wh.list.1': ' რჩება',
  'wh.list.2': 'ახალი',
  'wh.list.3': ' მოდელი',
  'wh.list.4': 'AI კითხულობს შეფუთვას...',
  'wh.list.5': 'AI გამორთულია — ჩართე პარამეტრებში (საკუთარი key) ან მოითხოვე ადმინისგან',
  'wh.list.6': 'AI-მ ვერ დაამუშავა ფოტო',
  'wh.list.7': 'ამოცნობილია — გადაამოწმე და შეავსე ფასები',
  'wh.list.8': 'ფოტოს დამუშავება ვერ მოხერხდა',
  'wh.list.9': 'პროდუქტი ნაპოვნია: {name}',
  'wh.list.10': 'შტრიხკოდი ვერ მოიძებნა — დაამატეთ ახალი პროდუქტი',
  'wh.list.11': 'აქციები',
  'wh.list.12': 'აქციები და კომბო — პროდუქტი აქციის ფასზე',
  'wh.list.13': 'შაბლონები',
  'wh.list.14': 'შაბლონ.',
  'wh.list.15': 'მზა კატეგორიები მაღაზიის ტიპის მიხედვით',
  'wh.list.16': 'მოდელი (ზომები)',
  'wh.list.17': 'მოდელი',
  'wh.list.18': 'ახალი მოდელი — ზომები და ფერები, ეტიკეტებით',
  'wh.list.19': 'ეტიკეტები',
  'wh.list.20': 'ეტიკეტ.',
  'wh.list.21': 'ეტიკეტების ბეჭდვა',
  'wh.list.22': 'ინვენტარიზაცია',
  'wh.list.23': 'ინვენტ.',
  'wh.list.24': 'დაშლა',
  'wh.list.25': 'დაშლა — ერთი პროდუქტი ნაწილებად',
  'wh.list.26': 'კატალოგი',
  'wh.list.27': 'კატალოგიდან დამატება — მზა სახელი, შტრიხკოდი და ფოტო',
  'wh.list.28': 'გადატანა',
  'wh.list.29': 'მარაგის გადატანა ფილიალებს შორის',
  'wh.list.30': 'AI დამატება',
  'wh.list.31': 'AI სწრაფი დამატება — გადაუღე ფოტო შეფუთვას',
  'wh.list.32': 'ძებნა სახელით ან შტრიხკოდით',
  'wh.list.33': 'შტრიხკოდის სკანირება კამერით',
  'wh.list.34': 'კატეგორიები',
  'wh.list.35': ' პროდუქტი',
  'wh.list.36': 'პროდუქცია',
  'wh.list.37': 'შტრიხკოდი...',
  'wh.list.38': 'ძებნა...',
  'wh.list.39': 'შაბლონის გადმოწერა',
  'wh.list.40': 'ექსპორტი',
  'wh.list.41': 'იმპორტი (Excel + ფოტოები)',
  'wh.list.42': 'პროდუქტები ვერ მოიძებნა',
  'wh.list.43': ' ზომა',
  'wh.list.44': ' · {p1} ფერი',
  'wh.list.45': '{name} — მოქმედებები',
  'wh.list.46': 'შტრიხკოდის გარეშე',
  'wh.list.47': 'მეტის ჩვენება · ',
  'wh.list.48': 'ფოტო',
  'wh.list.49': 'სახელი',
  'wh.list.50': 'კატეგ.',
  'wh.list.51': 'შეს.',
  'wh.list.52': 'გაყ.',
  'wh.list.53': 'მარაგი',
  'wh.list.54': 'ზომის/ფერის დამატება · სახელი, ფასი, ფოტო ყველა ზომაზე',
  'wh.list.55': 'ეტიკეტები — ყველა ზომა',
  'wh.list.56': 'მოდელის წაშლა — ყველა ზომა',
  'wh.list.57': '{name} — მოდელის წაშლა',
  'wh.list.58': 'რედაქტირება · ნაშთის შევსება',
  'wh.list.59': 'ჩამოწერა — გატეხილი, ვადაგასული, დაკარგული',
  'wh.list.60': 'ზომის წაშლა',
  'wh.list.61': 'სკანერით ვერ გაიყიდება. ასევე: შტრიხკოდი პროდუქტის ვინაობაა — მის გარეშე საერთო კატალოგში ვერ ხვდება, ანუ ვერც შენი ფოტო მიუვა სხვას და ვერც ზედნადები დაემთხვევა.',
  'wh.list.62': ' შტრიხკოდის გარეშე',
  'wh.list.63': 'თანმხლები პროდუქტები (კომბო)',
  'wh.list.64': ' პროდუქტი • გვ. ',
  'wh.list.65': 'პროდუქტის დამატება',
  'wh.list.66': 'იმპორტი',
  'wh.list.67': 'Excel ფაილი და ფოტოები',
  'wh.list.68': 'ამჟამად ნაჩვენები პროდუქტები',
  'wh.list.69': 'ცარიელი ფაილი იმპორტისთვის',
  'wh.list.70': 'მოქმედებები',
  'wh.list.71': ' · მარაგი ',
  'wh.list.72': 'თანმხლები (კომბო)',
  'wh.list.73': 'ჩამოწერა',
  'wh.list.74': 'გატეხილი, ვადაგასული, დაკარგული',
  'wh.list.75': ' ზომა · ',
  'wh.list.76': 'ზომის ან ფერის დამატება',
  'wh.list.77': 'სახელი, ფასი და ფოტო — ყველა ზომაზე',
  'wh.list.78': 'ყველა ზომა, მარაგის რაოდენობით',
  'wh.list.79': 'მოდელის წაშლა',
  'wh.list.80': 'ყველა ზომა ერთად',
  'wh.list.81': 'პროდუქტის მოძებნა',
  'wh.list.82': ' მზა კატეგორიები',
  'wh.list.83': '" — მოდელის წაშლა',
  'wh.list.84': 'წაიშლება ყველა ზომა ერთად: ',
  'wh.list.85': ' ({p1} ფერი)',
  'wh.list.86': 'მარაგში ',
  'wh.list.87': ' ცალია',
  'wh.list.88': ' (ყველა ფილიალში)',
  'wh.list.89': ' — წაშლის შემდეგ საწყობში აღარ ჩანს. თუ საქონელი დაიკარგა ან დაზიანდა, ჯერ ჩამოწერე.',
  'wh.list.90': 'გაყიდვების ისტორია და ანგარიშები რჩება — ჩეკებზე ზომის სახელი ინახება. ეს ქმედება შეუქცევადია.',
  'wh.list.91': '„{name}" წაიშალა — {p1} ზომა',
  'wh.list.92': 'წაშლა (',
  'wh.list.93': ' ზომა)',
  'wh.list.94': 'პროდუქტის წაშლა',
  'wh.list.95': 'ნამდვილად გსურთ ამ პროდუქტის წაშლა? ეს ქმედება შეუქცევადია.',
  'wh.list.96': 'პროდუქტი წაიშალა',
  'wh.product.1': '„{p1}" შეიქმნა და შეირჩა',
  'wh.product.2': 'შევსებულია საერთო კატალოგიდან',
  'wh.product.3': 'ფოტოს ოპტიმიზაცია მიმდინარეობს...',
  'wh.product.4': 'ფოტო შეიკუმშა: {originalSize}KB → {compressedSize}KB',
  'wh.product.5': 'ფოტოს ოპტიმიზაცია ვერ მოხერხდა',
  'wh.product.6': 'სახელი სავალდებულოა',
  'wh.product.7': 'მთავარი კატეგორია სავალდებულოა',
  'wh.product.8': 'ფასები სავალდებულოა',
  'wh.product.9': 'ფასი უარყოფითი ვერ იქნება',
  'wh.product.10': 'ეს შტრიხკოდი უკვე აქვს: {name} — გამოიყენე ნაშთის შევსება',
  'wh.product.11': 'PLU კოდი — მხოლოდ ციფრები (მაქს. 5)',
  'wh.product.12': 'ეს PLU უკვე აქვს: {name}',
  'wh.product.13': 'ფოტო იტვირთება...',
  'wh.product.14': 'ფოტო აიტვირთა',
  'wh.product.15': 'ფოტოს ატვირთვა ვერ მოხერხდა',
  'wh.product.16': 'ნაშთი შეივსო',
  'wh.product.17': 'პროდუქტი განახლდა',
  'wh.product.18': 'პროდუქტი დაემატა',
  'wh.product.19': 'კოდი მიენიჭა',
  'wh.product.20': '{p1} პროდუქტს მიენიჭა კოდი',
  'wh.product.21': 'ეტიკეტის ბეჭდვა',
  'wh.product.22': 'ეტიკეტები ({p1})',
  'wh.product.23': 'პროდუქტის რედაქტირება',
  'wh.product.24': 'ნაშთის შევსება',
  'wh.product.25': 'ახალი პროდუქტის დამატება',
  'wh.product.26': ' დამატებულია ',
  'wh.product.27': 'მოდელი ',
  'wh.product.28': ' · ზომა ',
  'wh.product.29': ' — სახელი, ფასი და ფოტო ყველა ზომაზე: მოდელის ✎',
  'wh.product.30': ' ზომები ან ფერები აქვს? დაამატე მოდელად',
  'wh.product.31': 'ნაპოვნია საერთო კატალოგში',
  'wh.product.32': 'კატეგორია: ',
  'wh.product.33': 'შეიქმნება: ',
  'wh.product.34': 'ფორმა დაბრუნდება ისე, როგორც იყო',
  'wh.product.35': ' გაუქმება',
  'wh.product.36': 'შევსება',
  'wh.product.37': 'შეიქმნება: {p1}',
  'wh.product.38': 'კატეგორიაც',
  'wh.product.39': 'დამალვა',
  'wh.product.40': 'ეს შტრიხკოდი უკვე არსებობს — ',
  'wh.product.41': '. ვავსებთ ნაშთს (ნაცვლად დუბლიკატისა).',
  'wh.product.42': 'სახელი ',
  'wh.product.43': 'მაგ: Samsung A54 ქეისი',
  'wh.product.44': 'შტრიხკოდი',
  'wh.product.45': 'სკანი ან ხელით',
  'wh.product.46': 'კამერით სკანირება',
  'wh.product.47': ' შტრიხკოდი არ აქვს? მიანიჭე კოდი',
  'wh.product.48': 'მაღაზიის კოდი — შენახვის მერე დაბეჭდე ეტიკეტი და მიაკარი ნივთს ან თაროს',
  'wh.product.49': 'PLU კოდი ',
  'wh.product.50': '— სასწორის ეტიკეტისთვის',
  'wh.product.51': 'მაგ: 42',
  'wh.product.pluHint': 'ის ნომერი, რომელიც სასწორს შტრიხკოდში ჩააქვს. ეტიკეტზე ხშირად „კოდი" ჰქვია და PLU-ს (ღილაკის ნომერს) არ ემთხვევა: „კოდი 004852" → 4852.',
  'wh.product.52': 'ვარგისია (მდე) ',
  'wh.exp.label': 'ვარგისია (მდე)',
  'wh.exp.hint': 'შეფუთვაზე დაბეჭდილი თარიღი. ცარიელი — თუ არ ფუჭდება',
  'wh.exp.track': 'ვადიანი პროდუქტი',
  'wh.exp.trackHint': 'მარაგი პარტიებად შემოდის, თითო თავისი ვადით',
  'wh.exp.past': 'ეს თარიღი უკვე გავიდა — ნამდვილად?',
  'wh.exp.pastOk': 'კი, სწორია',
  'wh.exp.pastConfirm': 'დაადასტურე წარსული თარიღი ან შეასწორე',
  'wh.exp.newBatch': 'ახალი პარტიის ვარგისიანობა',
  'wh.exp.batches': 'პარტიები',
  'wh.exp.undated': 'ვადა არ მითითებულა',
  'wh.exp.toList': 'ვადები →',
  'wh.exp.excelOne': 'Excel-ში მხოლოდ ყველაზე ადრეული ვადა ინახება; დანარჩენი პარტიები აქ, პროგრამაშია.',
  'wh.product.53': '— არასავალდებულო',
  'wh.product.54': 'შესყიდვა (₾) ',
  'wh.product.55': 'გაყიდვა (₾) ',
  'wh.product.56': 'საბითუმო (₾) ',
  'wh.product.57': '— არასავალდ.',
  'wh.product.58': 'ცარიელი = მხოლოდ საცალო',
  'wh.product.59': 'მთავარი კატ. ',
  'wh.product.60': 'აირჩიეთ...',
  'wh.product.61': 'ქვეკატეგორია',
  'wh.product.62': '+ ახალი ქვეკატეგორია',
  'wh.product.63': 'მარაგი ',
  'wh.product.64': ' ახლა: ',
  'wh.product.65': 'ნაშთს დაამატე',
  'wh.product.66': ' დამატება',
  'wh.product.67': 'ახალი მთლიანი ნაშთი',
  'wh.product.68': ' ახალი',
  'wh.product.69': 'დასამატებელი',
  'wh.product.70': 'ახალი მთლიანი',
  'wh.product.71': 'ნაშთი გახდება: ',
  'wh.product.72': ' · ფილიალში ',
  'wh.product.73': 'საწყისი მარაგი ჩაიწერება ფილიალში ',
  'wh.product.74': ' — ზედა ზოლში არჩეულში',
  'wh.product.75': 'მოსალოდნელი მოგება: ₾',
  'wh.product.margin': ' · მარჟა {pct}%',
  // 1.68 — where a dish goes, read from its category (the server's rule)
  'wh.product.station': 'სად მიდის: {station} (კატეგორიიდან)',
  'wh.product.stationNone': 'სად მიდის: არსად (წყალი, ქილა — მიმტანი თვითონ მიიტანს)',
  'wh.product.76': 'ფოტოს ატვირთვა',
  'wh.product.77': 'მიმდინარეობს ოპტიმიზაცია...',
  'wh.product.78': 'ფოტოს წაშლა',
  'wh.product.79': ' წაშლა',
  'wh.product.80': 'დააწკაპუნეთ აქ ფოტოს ასატვირთად',
  'wh.product.81': 'ავტომატური ოპტიმიზაცია (მაქს. 800px)',
  'wh.product.82': 'შენახვა და შემდეგი ',
  'wh.product.83': 'შტრიხკოდის სკანირება',
  'wh.model.1': 'მაქს. 40 სიმბოლო',
  'wh.model.2': 'მოდელის სახელი სავალდებულოა',
  'wh.model.3': 'კატეგორია სავალდებულოა',
  'wh.model.4': 'აირჩიე ზომები ან ფერები',
  'wh.model.5': 'გაყიდვის ფასი არასწორია',
  'wh.model.6': 'საბითუმო ფასი არასწორია',
  'wh.model.7': 'გაყიდვის ფასი სავალდებულოა',
  'wh.model.8': 'შესყიდვის ფასი სავალდებულოა',
  'wh.model.9': 'შტრიხკოდი {code} ორჯერაა: {seen} და {label}',
  'wh.model.10': 'შტრიხკოდი {code} უკვე აქვს: {name}',
  'wh.model.11': 'რაოდენობა ყველა ახალ ზომაზე 0-ია. თუ საქონელი ჯერ არ მოსულა, დააჭირე კიდევ ერთხელ',
  'wh.model.12': 'ფოტოს ატვირთვა ვერ მოხერხდა',
  'wh.model.13': 'ცვლილება არ არის',
  'wh.model.14': 'მოდელი განახლდა — ყველა ზომაზე',
  'wh.model.15': '„{name}" — ზომები და ფერები',
  'wh.model.16': 'ახალი მოდელი — ზომები და ფერები',
  'wh.model.17': 'თითო ზომა ცალკე პროდუქტია — თავისი მარაგით და შტრიხკოდით. სალაროში მოდელი ერთ ბარათად ჩანს და ზომას იქვე ირჩევ.',
  'wh.model.18': 'მოდელის სახელი ',
  'wh.model.19': 'მაგ. Nike Air Max 90',
  'wh.model.24': 'შესყიდვა (₾)',
  'wh.model.25': 'მხოლოდ ახალ ზომებზე',
  'wh.model.26': 'გაყიდვა (₾)',
  'wh.model.27': 'სხვადასხვა',
  'wh.model.28': 'ფასები არ იცვლება · ახალი ზომები: ₾{maxPrice}',
  'wh.model.29': 'ყველა ზომაზე',
  'wh.model.30': 'საბითუმო (₾)',
  'wh.model.31': 'არასავალდ.',
  'wh.model.32': 'საერთო ფოტო',
  'wh.model.33': 'ფოტო',
  'wh.model.34': 'ფოტოს წაშლა',
  'wh.model.35': 'საერთო ფოტო — ფერს თავისიც შეიძლება, ქვემოთ',
  'wh.model.36': 'ფოტო — ყველა ზომას ერთი',
  'wh.model.37': 'ზომები',
  'wh.model.38': 'ამ ზომას უკვე აქვს მარაგი',
  'wh.model.39': 'სხვა ზომა',
  'wh.model.40': 'ზომის დამატება',
  'wh.model.41': 'ფერები ',
  'wh.model.42': '— არასავალდებულო',
  'wh.model.43': 'სხვა ფერი',
  'wh.model.44': 'ფერის დამატება',
  'wh.model.47': '{c} — ფოტო',
  'wh.model.48': '{c} — საკუთარი ფოტოს მოხსნა',
  'wh.model.49': 'თავისი',
  'wh.model.50': 'საერთო',
  'wh.model.51': 'ფოტოს გარეშე',
  'wh.model.addPhoto': '+ საკუთარი ფოტო',
  'wh.model.52': 'რაოდენობა',
  'wh.model.53': ' და შტრიხკოდი',
  'wh.model.54': 'ყველას',
  'wh.model.55': 'აირჩიე ზომები (ან ფერები) — აქ ბადე გამოჩნდება',
  'wh.model.56': 'ერთი ზომა',
  'wh.model.58': 'ცარიელია — არ შეიქმნება',
  'wh.model.59': '{p1} — რაოდენობა',
  'wh.model.60': 'ავტო',
  'wh.model.61': '{p1} — შტრიხკოდი',
  'wh.model.62': 'დაასკანერე მომწოდებლის შტრიხკოდი თითო ზომაზე. ცარიელი = მაღაზიის კოდი (29…) თვითონ შეიქმნება.',
  'wh.model.63': 'შტრიხკოდი მაღაზიის კოდით (29…) თვითონ შეიქმნება და ეტიკეტზე დაიბეჭდება.',
  'wh.model.64': 'დამალვა',
  'wh.model.65': 'მომწოდებლის კოდი მაქვს',
  'wh.model.66': 'რაოდენობა 0-ია — კიდევ ერთი დაჭერა შეინახავს 0-ით',
  'wh.model.67': 'ემატება',
  'wh.model.68': 'შეიქმნება',
  'wh.model.69': ' ზომა · ',
  'wh.model.70': ' ცალი',
  'wh.model.71': ' მომწოდებლის კოდი შეინახება',
  'wh.model.72': ' · ფილიალში „',
  'wh.model.73': 'ცარიელი არ შეიქმნება: ',
  'wh.model.74': ' და კიდევ {p1}',
  'wh.model.75': 'ცვლილება ყველა ზომას შეეხება',
  'wh.model.76': ' შენახვა და ეტიკეტები',
  'wh.model.category': 'კატეგორია ',
  'wh.model.selectAll': 'ყველას მონიშვნა',
  'wh.model.clearSizes': 'გასუფთავება',
  'wh.model.shopColors': 'შენი:',
  'wh.model.wholesaleClear': 'წაშლა ყველა ზომაზე',
  'wh.model.wholesaleCleared': 'საბითუმო ფასი წაიშლება ყველა ზომაზე',
  'wh.model.stepBasics': 'მოდელი და ფასები',
  'wh.model.stepVariants': 'ზომები და ფერები',
  'wh.model.stepQuantities': 'რაოდენობები და კოდები',
  'wh.model.addColor': 'ფერის დამატება',
  'wh.model.removeColor': '{color} — ფერის მოხსნა',
  'wh.model.codeAuto': 'ავტომატური კოდი',
  'wh.model.codeSupplier': 'მომწოდებლის კოდი',
  'wh.model.allNew': 'ყველა ახალ ვარიანტში',
  'wh.model.summary': '{colors} ფერი × {sizes} ზომა · {variants} ახალი · {units} ცალი',
  'wh.model.summaryNoColor': 'ფერის გარეშე · {sizes} ზომა · {variants} ახალი · {units} ცალი',
  'wh.matrix.color': 'ფერი',
  'wh.matrix.total': 'სულ',
  'wh.cat.search': 'აირჩიე ან მოძებნე…',
  'wh.cat.none': 'ვერ მოიძებნა',
  'wh.cat.newUnder': '{root} › + ახალი ქვეკატეგორია',
  'wh.countPhone.1': 'კატეგორია',
  'wh.countPhone.2': 'მთელი მაღაზია',
  'wh.countPhone.3': 'შტრიხკოდი {code} ვერ მოიძებნა',
  'wh.countPhone.4': 'ინვენტარიზაციის დაწყება ვერ მოხერხდა',
  'wh.countPhone.5': 'გაუქმება ვერ მოხერხდა',
  'wh.countPhone.6': 'ინვენტარიზაცია გაუქმდა',
  'wh.countPhone.7': 'ჯერ არაფერი დაგითვლიათ',
  'wh.countPhone.8': 'ჩატვირთვა ვერ მოხერხდა',
  'wh.countPhone.10': 'დასრულება ვერ მოხერხდა',
  'wh.countPhone.11': 'ინვენტარიზაცია',
  'wh.countPhone.12': 'მეტი',
  'wh.countPhone.14': 'თვლა შენთვის გამორთულია',
  'wh.countPhone.15': 'მფლობელს თვლა ჯერ არ დაუწყია',
  'wh.countPhone.16': 'მფლობელს შეუძლია ჩართოს: თანამშრომლები → „მოლარეც დამეხმარება".',
  'wh.countPhone.17': 'როცა დაიწყებს, აქ გამოჩნდება.',
  'wh.countPhone.18': 'შეამოწმე ინტერნეტი და სცადე თავიდან. დათვლილი არაფერი იკარგება.',
  'wh.countPhone.19': 'თავიდან ცდა',
  'wh.countPhone.20': 'განახლება',
  'wh.countPhone.26': '{p1} პროდუქტი',
  'wh.countPhone.27': '{n} პროდუქტი',
  'wh.countPhone.32': 'ვერაფერი მოიძებნა',
  'wh.countPhone.34': ' — ყველაფერი დათვლილია',
  'wh.countPhone.37': 'შტრიხკოდის გარეშე',
  'wh.countPhone.39': 'ჯერ არაფერი დაგითვლიათ — დაასკანერე ან აირჩიე სიიდან',
  'wh.countPhone.41': 'პროდუქტის ძებნა',
  'wh.countPhone.42': 'გასუფთავება',
  'wh.countPhone.43': 'სკანირება კამერით',
  'wh.countPhone.44': 'ყველა დათვლილი პროდუქტი ემთხვევა სისტემას',
  'wh.countPhone.51': 'თვლის გაგრძელება',
  'wh.countPhone.55': 'ყოველი „დამატება" მაშინვე ინახება — ტელეფონის დაბლოკვა ან დახურვა არაფერს კარგავს.',
  'wh.countPhone.56': 'რას ვითვლით',
  'wh.countPhone.57': 'ინვენტარიზაციის გაუქმება',
  'wh.countPhone.58': 'დიახ, გაუქმდეს — ყველა ტელეფონის თვლა წაიშლება',
  'wh.countPhone.63': 'ინვენტარიზაცია — დაასკანერე',
  'wh.countPhone.64': 'დათვლილი პროდუქტი',
  'wh.countPhone.65': 'დანაკლისი',
  'wh.countPhone.66': 'ზედმეტი',
  'wh.countPhone.67': 'ცალი',
  'wh.countPhone.68': 'რაოდენობა არასწორია',
  'wh.countPhone.70': 'ერთით ნაკლები',
  'wh.countPhone.73': 'ერთით მეტი',
  'wh.count.1': 'ღია ინვენტარიზაცია სხვა ფილიალშია: {bn}',
  'wh.count.2': 'ღია ინვენტარიზაცია სხვა ფილიალშია',
  'wh.count.3': 'ინვენტარიზაციის დაწყება ვერ მოხერხდა',
  'wh.count.4': 'შტრიხკოდი {code} ბაზაში ვერ მოიძებნა',
  'wh.count.5': 'ჯერ არაფერი დაგითვლიათ',
  'wh.count.6': 'დასრულება ვერ მოხერხდა',
  'wh.count.7': 'მარაგი გასწორდა ინვენტარიზაციის მიხედვით',
  'wh.count.8': 'ინვენტარიზაცია შენახულია (მარაგი უცვლელია)',
  'wh.count.9': 'ინვენტარიზაცია გაუქმდა',
  'wh.count.10': 'ინვენტარიზაცია',
  'wh.count.11': 'დათვლილია {p1} პროდუქტი',
  'wh.count.12': 'დაითვალე თაროები და შეადარე სისტემას',
  'wh.count.13': 'ინვენტარიზაცია დასრულდა',
  'wh.count.14': 'დათვლილი',
  'wh.count.15': 'დანაკლისი',
  'wh.count.16': 'ზედმეტი',
  'wh.count.17': 'მარაგი გასწორებულია დათვლილის მიხედვით.',
  'wh.count.18': 'მარაგი არ შეცვლილა — მხოლოდ ანგარიშია.',
  'wh.count.19': 'კარგი',
  'wh.count.20': 'დაიწყე ინვენტარიზაცია',
  'wh.count.21': 'დაასკანერე პროდუქცია სკანერით ან ტელეფონის კამერით — სისტემა შეადარებს მარაგს და გაჩვენებს დანაკლისს.',
  'wh.count.22': ' დაწყება',
  'wh.count.23': ' ბოლო ინვენტარიზაციები',
  'wh.count.24': ' პროდ.',
  'wh.count.25': 'გასწორდა',
  'wh.count.26': 'ანგარიში',
  'wh.count.27': 'შტრიხკოდი (სკანერი ან ხელით)...',
  'wh.count.28': ' კამერა',
  'wh.count.29': 'ან მოძებნე სახელით...',
  'wh.count.30': 'მარაგი: ',
  'wh.count.31': 'ემთხვევა',
  'wh.count.32': ' ც · ₾',
  'wh.count.33': 'დაასკანერე პირველი პროდუქტი',
  'wh.count.34': 'სისტემა',
  'wh.count.35': 'სხვაობა',
  'wh.count.36': 'შენახვა კორექციის გარეშე',
  'wh.count.37': ' დაასრულე და გაასწორე მარაგი',
  'wh.count.38': 'ინვენტარიზაცია — დაასკანერე პროდუქცია',
  'wh.count.removeFailed': 'ხაზი ვერ წაიშალა — ისევ დათვლაშია, სცადე თავიდან',
  'wh.import.1': '{p1} მწკრივი წაიკითხა',
  'wh.import.2': 'Excel ფაილის წაკითხვა ვერ მოხერხდა',
  'wh.import.3': 'ZIP-ის წაკითხვა ვერ მოხერხდა: {name}',
  'wh.import.4': '{count} ფოტო არჩეულია',
  'wh.import.5': 'ჯერ აირჩიეთ Excel ფაილი',
  'wh.import.6': 'ფოტო ვერ აიტვირთა',
  'wh.import.7': '{p1} ახალი პროდუქტი ({withPhotos} ფოტოთი)',
  'wh.import.8': '{p1} არსებულს ნაშთი შეევსო',
  'wh.import.9': 'იმპორტი დასრულდა: {parts}',
  'wh.import.10': '{failCount} მწკრივი გამოტოვდა (სახელის გარეშე)',
  'wh.import.11': '{dupSizes} მწკრივი გამოტოვდა — ეს ზომა და ფერი მოდელს უკვე აქვს',
  'wh.import.12': '{folded} მწკრივი გაერთიანდა — ერთი და იგივე პროდუქტი (შტრიხკოდით, დამატებითი კოდით ან PLU-თი) ფაილში რამდენჯერმე ეწერა, რაოდენობები შეიკრიბა',
  'wh.import.13': 'ერთ პროდუქტად ჩაიწერა პირველი სახელით. შეამოწმე.',
  'wh.import.14': '{pricelessCount} მწკრივი გამოტოვდა — გაყიდვის ფასი არ აქვს. ',
  'wh.import.15': 'ფასის გარეშე პროდუქტს სალარო უფასოდ გასცემს.',
  'wh.import.16': 'პროდუქციის იმპორტი',
  'wh.import.17': 'ატვირთე Excel და (სურვილისამებრ) ფოტოები — ფოტოები ავტომატურად დაემთხვევა და აიტვირთება R2-ზე.',
  'wh.import.18': '1. Excel ფაილი ',
  'wh.import.19': '{excelName} — {p1} მწკრივი',
  'wh.import.20': 'აირჩიეთ .xlsx ფაილი',
  'wh.import.21': 'არჩევა',
  'wh.import.22': '2. ფოტოები ',
  'wh.import.23': '(არასავალდებულო)',
  'wh.import.24': '{imageCount} ფოტო — {matchedCount} დაემთხვა',
  'wh.import.25': 'ფოტოები ან ZIP — დაერქმევა "ფოტოს ფაილი" სვეტით ან barcode-ით',
  'wh.import.26': 'რა მოხდება',
  'wh.import.27': 'ახალი პროდუქტი',
  'wh.import.28': 'ნაშთი შეევსება',
  'wh.import.29': 'მარაგი გაიზრდება',
  'wh.import.30': 'ხარჯად ჩაიწერება',
  'wh.import.31': ' მწკრივს გაყიდვის ფასი არ აქვს — გამოტოვდება. ფასის გარეშე პროდუქტს სალარო უფასოდ გასცემს.',
  'wh.import.32': '⚠️ ეს ჩვენივე ძველი ექსპორტია და „რაოდენობა" შევსებულია — ანუ მარაგი',
  'wh.import.33': ' დაემატება არსებულს',
  'wh.import.34': ', არა შეიცვლება. თუ მხოლოდ ფასების გასწორება გინდა, გაასუფთავე „რაოდენობა" სვეტი.',
  'wh.import.35': 'ფოტოთი',
  'wh.import.36': 'ფოტოს გარეშე',
  'wh.import.37': ' ფოტოები იტვირთება...',
  'wh.import.38': ' იმპორტი...',
  'wh.import.checking': ' მოწმდება...',
  'wh.import.39': 'იმპორტი (',
  'wh.import.creating': ' ახალი პროდუქტები იწერება...',
  'wh.import.stocking': ' ნაშთი იწერება...',
  'wh.import.keepOpen': 'ფანჯარას ნუ დახურავ, სანამ იმპორტი არ დასრულდება — 30 000 ხაზს რამდენიმე წუთი სჭირდება.',
  'wh.import.mode': 'რა არის ეს ფაილი',
  'wh.import.modeReceive': 'მიღება (შესყიდვა)',
  'wh.import.modeOpening': 'საწყისი ნაშთი',
  'wh.import.modeReceiveHint': 'მომწოდებლისგან მოსული საქონელი: რაოდენობა ნაშთს ემატება და შესყიდვად (ხარჯად) ჩაიწერება.',
  'wh.import.modeOpeningHint': 'სხვა პროგრამიდან (მაგ. FINA, Optimo) გადმოგაქვს უკვე არსებული საქონელი: ფილიალის ნაშთი ფაილის რაოდენობა გახდება. იგივე ფაილის თავიდან ატვირთვა არაფერს გააორმაგებს.',
  'wh.import.openingExisting': 'უკვე საწყობშია',
  'wh.import.openingSet': 'ნაშთი დაყენდება (ერთეული)',
  'wh.import.openingNoPurchase': 'არ ჩაიწერება',
  'wh.import.branchNote': 'ნაშთი ჩაიწერება ფილიალში: {name}. სხვა ფილიალისთვის ჯერ ზედა მენიუდან ის აირჩიე.',
  'wh.import.openingNoBarcode': '{n} ხაზს შტრიხკოდი არ აქვს — ასეთი პროდუქტი ყოველ ატვირთვაზე ახლად შეიქმნება.',
  // 158 — a row's codes refused, named by its Excel row
  'wh.import.codeRefused': 'Excel-ის ხაზი {row}: {why}. არაფერი ჩაიწერა ამ ნაწილიდან — გაასწორე და ატვირთე ისევ.',
  'wh.import.codeRefusedNoRetry': 'Excel-ის ხაზი {row}: {why}. ფაილის ნაწილი უკვე ჩაიწერა — ხელახლა ნუ ატვირთავ, ჯერ მოგვწერე.',
  'wh.import.codeRefusedRow': 'Excel-ის ხაზი {row}: {why}.',
  'wh.import.refused': '{n} ხაზი არ შევიდა: {list}{more}',
  'wh.import.refusedRow': 'ხაზი {row} — {why}',
  'wh.import.previewRefused': '{n} ხაზი არ შევა (კოდის კონფლიქტი ან ზედმეტი კოდები)',
  'wh.import.why.conflict': 'კოდი {code} სხვა პროდუქტს ეკუთვნის',
  'wh.import.why.conflictGroup': 'ხაზის კოდები სხვადასხვა პროდუქტს ეკუთვნის',
  'wh.import.why.plu': 'PLU არ ემთხვევა (სხვა პროდუქტს აქვს ან პროდუქტს სხვა PLU უწერია)',
  'wh.import.why.tooMany': '10-ზე მეტი დამატებითი კოდი',
  'wh.import.why.invalid': 'კოდი ძალიან გრძელია',
  'wh.import.why.badPlu': 'PLU 5 ციფრზე გრძელია',
  'wh.import.newCats': 'შეიქმნება {n} ახალი კატეგორია: {names}',
  'wh.import.catsFailed': 'ფაილის კატეგორიები ვერ შეიქმნა — იმპორტი არ დაწყებულა, არაფერი ჩაწერილა.',
  'wh.import.partialOpening': 'ჩაიწერა {done} ხაზი.',
  'wh.import.partialOpeningTotal': 'სულ იყო {total} ხაზი; დანარჩენი არ ჩაიწერა. უბრალოდ ატვირთე იგივე ფაილი თავიდან: უკვე ჩაწერილი ხაზები არ შეიცვლება და არ გაორმაგდება.',
  'wh.import.openingDone': 'საწყისი ნაშთი ჩაიწერა: {total} ხაზი, აქედან {created} ახალი პროდუქტი.',
  'wh.import.openingBook': 'ნაშთის ღირებულება ჩაიწეროს ბუღალტერიაში („საწყისი ნაშთი")',
  'wh.import.openingBookHint': 'ერთი შესყიდვა — გადახდილი, მომწოდებლის გარეშე. ნაშთი და მოგება არ იცვლება; ბუღალტერიაში უბრალოდ ჩანს, რა ღირებულების საქონლით დაიწყო მაღაზია.',
  'wh.import.openingBookedAlready': 'ამ ფილიალში უკვე ჩაწერილია: {date}, ₾{sum}. ფაილის ახალი პროდუქტები მას დაემატება, უკვე ჩაწერილი მეორედ არ ჩაიწერება.',
  'wh.import.openingBookedNothing': '„საწყისი ნაშთი" ბუღალტერიაში უკვე ჩაწერილია — მეორედ არაფერი ჩაწერილა.',
  'wh.import.partialOpeningNoBarcode': 'სულ იყო {total} ხაზი; დანარჩენი არ ჩაიწერა. ⚠️ ფაილში {n} ხაზს შტრიხკოდი არ აქვს — თავიდან ატვირთვისას ისინი მეორედ შეიქმნება. თავიდან ნუ ატვირთავთ, ჯერ დაგვიკავშირდით.',
  'wh.import.openingValue': '≈ ₾{sum} („საწყისი ნაშთი")',
  'wh.import.openingCostless': '{n} პროდუქტს თვითღირებულება არ აქვს (₾0): გაყიდვისას მათი მოგება გაზვიადებული გამოჩნდება. სჯობს, ფაილში შესყიდვის ფასი შეავსოთ.',
  'wh.import.openingBooked': 'ბუღალტერიაში ჩაიწერა „საწყისი ნაშთი": ₾{sum}.',
  'wh.import.openingBookFailed': 'ნაშთი ჩაიწერა, მაგრამ ბუღალტერიაში {missing} პროდუქტის ღირებულება ვერ ჩაიწერა. ატვირთეთ იგივე ფაილი თავიდან — ნაშთი არ გაორმაგდება, დარჩენილი ღირებულება კი ჩაიწერება.',
  'wh.import.afterSalesTitle': 'ამ ფილიალში უკვე იყო გაყიდვები',
  'wh.import.afterSalesCount': 'სულ {n} გაყიდვა — ნაშთი მას შემდეგ შეიცვალა.',
  'wh.import.afterSalesConsequence': 'თუ გააგრძელებ, ფაილის თითოეული პროდუქტის ნაშთი ფაილში ჩაწერილი რიცხვით შეიცვლება. თუ ფაილი გაყიდვებამდეა მომზადებული, უკვე გაყიდული საქონელი ნაშთში ისევ დაბრუნდება. გააგრძელე მხოლოდ მაშინ, თუ ფაილში დღევანდელი ნაშთია.',
  'wh.import.afterSalesContinue': 'მაინც გაგრძელება',
  'wh.import.partialCreate': 'ჩაიწერა {done} ახალი პროდუქტი.',
  'wh.import.partialCreateTotal': 'სულ იყო {total} ახალი პროდუქტი; დანარჩენი არ ჩაიწერა. თავიდან ატვირთვამდე ფაილიდან ამოიღე უკვე ჩაწერილი ახალი პროდუქტები: ისინი უკვე საწყობშია და მეორედ ნაშთს დაუმატებდა.',
  'wh.import.partialStock': 'ნაშთი შეევსო {done} პროდუქტს.',
  'wh.import.partialStockTotal': 'სულ იყო {total} პროდუქტი; დანარჩენს ნაშთი არ შეევსო. თავიდან ატვირთვამდე ფაილიდან ამოიღე უკვე შევსებულები, თორემ მათი ნაშთი გაორმაგდება.',
  'wh.promo.1': 'ამ კატეგორიაში ახალი პროდუქტი არ არის',
  'wh.promo.2': '{p1} პროდუქტი დაემატა',
  'wh.promo.3': 'აქციას სახელი დაარქვი',
  'wh.promo.4': 'დაამატე მინიმუმ ერთი პროდუქტი',
  'wh.promo.5': 'ფასდაკლება 1–100% უნდა იყოს',
  'wh.promo.6': 'კომბოს ფასი ჩაწერე',
  'wh.promo.7': 'რაოდენობა 0-ზე მეტი უნდა იყოს',
  'wh.promo.8': 'კომბოში მინიმუმ 2 ცალი უნდა იყოს (მაგ. 2 ცალი ერთი პროდუქტის)',
  'wh.promo.9': 'კომბოს ფასი (₾{bundle_price}) ცალკე ფასებზე (₾{bundleList}) ნაკლები უნდა იყოს',
  'wh.promo.10': 'დასრულება დაწყებამდე არ შეიძლება',
  'wh.promo.11': 'აქცია განახლდა',
  'wh.promo.12': 'აქცია შეიქმნა — სალარო ავტომატურად გამოიყენებს',
  'wh.promo.13': 'აქციის რედაქტირება',
  'wh.promo.14': 'ახალი აქცია',
  'wh.promo.15': 'აქციები და კომბო',
  'wh.promo.16': 'პროდუქტი (ან რამდენიმე) აქციის ფასზე, ან კომბო — „ყავა + ნამცხვარი ₾6", „3 ცალი ₾25". სალარო და კიოსკი ფასს',
  'wh.promo.17': ' თავისით',
  'wh.promo.18': ' ითვლის; მოლარეს ხელით არაფერი უწევს. აქცია მოლარის ფასდაკლების ლიმიტს არ ითვლის.',
  'wh.promo.19': ' ახალი აქცია',
  'wh.promo.20': 'აქცია ჯერ არ არის',
  // 1.58
  'wh.pack.title': 'ყუთი',
  'wh.pack.sub': 'მარაგი ცალებში რჩება. ყუთის კოდის დასკანერებისას სალაროში მთელი ყუთი ემატება.',
  'wh.pack.qty': 'ყუთში ცალი',
  'wh.pack.price': 'ყუთის ფასი',
  'wh.pack.pricePh': 'არასავალდებულო',
  'wh.pack.code': 'ყუთის შტრიხკოდი',
  'wh.pack.codePh': 'არასავალდებულო',
  'wh.pack.box': 'ყუთი',
  'wh.pack.noPrice': 'ყუთში {qty} ცალია. ფასი არ აქვს: ყუთი ცალის ფასით გაიყიდება.',
  'wh.pack.tooHigh': 'ყუთის ფასი ცალების ჯამზე ({sum}) ნაკლები უნდა იყოს.',
  'wh.pack.addedWithout': 'პროდუქტი დაემატა, ყუთი კი ვერ შეინახა. გახსენით პროდუქტი და ყუთი ხელახლა შეინახეთ.',
  'wh.pack.droppedNotSaved': 'პროდუქტი ვერ შეინახა, ყუთი კი მოხსნილი დარჩა. შეამოწმეთ ინტერნეტი და შეინახეთ ხელახლა.',
  'wh.pack.dropOnKind': 'ყუთი შენახვისას მოიხსნება: წონით, მომსახურებას და სერიულნომრიან პროდუქტს ყუთი არ აქვს.',
  'wh.promo.packNote': '+ {n} პროდუქტს აქვს ყუთის ფასი — ის პროდუქტის ფანჯარაში იცვლება.',
  'wh.promo.21': 'კომბო',
  'wh.promo.22': 'ფასი',
  'wh.promo.23': 'გამორთვა',
  'wh.promo.24': 'ჩართვა',
  'wh.promo.25': 'სახელი',
  'wh.promo.26': 'მაგ. შემოდგომის ფასდაკლება',
  'wh.promo.27': 'ფასდაკლება',
  'wh.promo.28': 'კომბო / ერთად',
  'wh.promo.29': '% ყველაზე',
  'wh.promo.30': 'ფასი თითოეულზე',
  'wh.promo.31': 'კომბოს ფასი',
  'wh.promo.32': 'ცალკე ₾',
  'wh.promo.33': ' · დანაზოგი ₾',
  'wh.promo.34': 'პროდუქტის სახელი ან შტრიხკოდი…',
  'wh.promo.35': 'კატეგორიით…',
  'wh.promo.36': 'მოძებნე და დაამატე პროდუქტები',
  'wh.promo.37': 'წაშლილი პროდუქტი',
  'wh.promo.38': 'ც.',
  'wh.promo.39': 'კალათაში ყოველი სრული კომპლექტი კომბოს ფასს იღებს, დანარჩენი — ჩვეულებრივ ფასს. „3 ცალი ₾25" = ერთი პროდუქტი, რაოდენობა 3.',
  'wh.promo.40': 'დაწყება',
  'wh.promo.41': 'დასრულება',
  'wh.promo.42': 'ცარიელი = ახლავე / გამორთვამდე. დასრულების დღე ჩათვლილია.',
  'wh.promo.43': 'ჩართული',
  'wh.promo.44': 'აქციის წაშლა',
  'wh.promo.45': 'უკვე გაყიდულ ხაზებზე ფასდაკლება რჩება, მაგრამ აქციის სახელი ისტორიაში აღარ ჩანდება. თუ მხოლოდ შეჩერება გინდა — გამორთე.',
  'wh.catalog.1': '{made} კატეგორია შეიქმნა',
  'wh.catalog.2': 'ყველა კატეგორია უკვე არსებობს',
  'wh.catalog.3': '{n} პროდუქტს ფოტო დაემატა',
  'wh.catalog.4': 'კატალოგში შესაბამისი ფოტო ვერ მოიძებნა',
  'wh.catalog.5': 'მარჟა არასწორია',
  'wh.catalog.6': 'ჯერ თვითღირებულება შეავსე — მარჟა მისგან ითვლის',
  'wh.catalog.7': '{filled} ფასი შეივსო',
  'wh.catalog.8': '{n} პროდუქტი დაემატა — მარაგი 0, შეავსე მიღებისას',
  'wh.catalog.9': ' კატალოგიდან დამატება',
  'wh.catalog.10': 'სხვა მაღაზიების მიერ გაზიარებული პროდუქცია — სახელი, შტრიხკოდი და ფოტო მზადაა. მონიშნე რასაც ყიდი და ფასი დაწერე. ',
  'wh.catalog.11': 'მარაგი 0-ით დაემატება',
  'wh.catalog.12': ' — შეავსებ, როცა საქონელი მოვა.',
  'wh.catalog.13': ' პროდუქტს ფოტო აკლია',
  'wh.catalog.14': 'შტრიხკოდით მოძებნის კატალოგში და შეავსებს — უკვე დამატებულ პროდუქციასაც',
  'wh.catalog.15': 'ფოტოების შევსება',
  'wh.catalog.16': 'ჯერ ერთი კატეგორია მაინც შექმენი — პროდუქტი კატეგორიის გარეშე ვერ ინახება.',
  'wh.catalog.17': 'ძებნა',
  'wh.catalog.18': 'სახელი ან შტრიხკოდი…',
  'wh.catalog.19': 'გამოიყენება მხოლოდ იმ ხაზებზე, რომელთა კატეგორიაც კატალოგმა ვერ ამოიცნო',
  'wh.catalog.20': 'კატეგორია (ნაგულისხმევი)',
  'wh.catalog.21': 'მარჟა %',
  'wh.catalog.22': 'ფასების შევსება',
  'wh.catalog.23': ' იტვირთება…',
  'wh.catalog.24': 'ვერაფერი მოიძებნა',
  'wh.catalog.25': 'კატალოგში ახალი არაფერია — ყველაფერი უკვე გაქვს',
  'wh.catalog.26': 'თვითღ.',
  'wh.catalog.27': 'გასაყიდი',
  'wh.catalog.28': ' კატეგორია ჯერ არ გაქვს',
  'wh.catalog.29': 'შექმნა',
  'wh.catalog.30': 'მონიშნულია ',
  'wh.catalog.31': ' ფასის გარეშე',
  'wh.catalog.32': ' კატეგორიის გარეშე',
  'wh.catalog.33': ' ემატება…',
  'wh.catalog.34': ' პროდუქტის დამატება',
  'wh.addons.1': 'კატეგორია "{name}"',
  'wh.addons.2': '{where} — {p1} თანმხლები შენახულია',
  'wh.addons.3': '{where} — თანმხლები გასუფთავდა',
  'wh.addons.4': 'თანმხლები პროდუქტები',
  'wh.addons.5': ' მხოლოდ ეს პროდუქტი',
  'wh.addons.6': 'კატეგორია: {name}',
  'wh.addons.7': 'პროდუქტს კატეგორია არ აქვს',
  'wh.addons.8': 'მთელი „',
  'wh.addons.9': 'როცა მოლარე ',
  'wh.addons.10': '-ს გაყიდის, სალაროში გამოჩნდება აქ არჩეული პროდუქტები ერთი შეხებით დასამატებლად.',
  'wh.addons.11': 'კატეგორიიდან უკვე მოდის: ',
  'wh.addons.12': ' — აქ დამატება მხოლოდ ამ პროდუქტს ეხება.',
  'wh.addons.13': 'წესი გავრცელდება კატეგორია ',
  'wh.addons.14': '-ის ყველა პროდუქტზე — ახლა ',
  'wh.addons.15': ' ცალია, და ',
  'wh.addons.16': 'მომავალში დამატებულებზეც',
  'wh.addons.17': ' ავტომატურად იმუშავებს. ერთხელ აწყობ და ყველა ყავას მოერგება.',
  'wh.addons.18': 'ჯერ არაფერია არჩეული',
  'wh.addons.19': 'წაშლილი პროდუქტი',
  'wh.addons.20': ' · მარაგი ',
  'wh.addons.21': 'ავტომატურად ემატება კალათაში',
  'wh.addons.22': 'მხოლოდ შეთავაზება — მოლარე ირჩევს',
  'wh.addons.23': 'ავტომატური',
  'wh.addons.24': 'შეთავაზება',
  'wh.addons.25': 'მოძებნე დასამატებელი პროდუქტი...',
  'wh.addons.26': 'ვერაფერი მოიძებნა',
  'wh.addons.kind.offer': 'შეთავაზება',
  'wh.addons.kind.auto': 'ავტომატური',
  'wh.addons.kind.included': 'ფასში შედის',
  'wh.addons.kind.includedHint': 'ყოველ გაყიდულ ცალს მარაგიდან ჩამოეჭრება; ფასი არ იცვლება',
  'wh.addons.unit.piece': 'ც.',
  'wh.addons.unit.g': 'გ',
  'wh.addons.unit.ml': 'მლ',
  'wh.addons.unit.m': 'მ',
  'wh.addons.amount': 'რაოდენობა',
  'wh.addons.perUnit': 'ერთ გაყიდულ ცალზე',
  'wh.addons.badAmount': 'ჩაწერე მთელი რიცხვი: ცალი, გრამი ან მილილიტრი',
  'wh.addons.byWeight': 'წონით გაყიდვაზე არ მუშაობს',
  'wh.addons.notStock': 'მომსახურება ან სერიული პროდუქტი ფასში ვერ შევა — მხოლოდ შეთავაზება',
  'wh.addons.fromCategory': 'კატეგორიიდან უკვე მოდის',
  'wh.addons.notHere': 'ამ პროდუქტზე არა',
  'wh.addons.summary': 'ყოველ გაყიდულ ცალს ჩამოეჭრება: {list}. ფასი არ იცვლება — მყიდველი მხოლოდ თავად პროდუქტს იხდის.',
  'wh.tree.1': 'სახელი სავალდებულოა',
  'wh.tree.2': 'კატეგორია განახლდა',
  'wh.tree.3': 'კატეგორია დაემატა',
  'wh.tree.4': 'კატეგორიის წაშლა შეუძლებელია, რადგან ის შეიცავს პროდუქტებს ან ქვეკატეგორიებს.',
  'wh.tree.5': 'კატეგორია წაიშალა',
  'wh.tree.6': 'კატეგორიები',
  'wh.tree.7': 'მთავარი კატეგორიის დამატება',
  'wh.tree.8': 'ყველა პოზიცია',
  'wh.tree.9': 'ქვეკატეგორიის დამატება',
  'wh.tree.10': 'კატეგორიის რედაქტირება',
  'wh.tree.11': 'ახალი კატეგორია',
  'wh.tree.12': 'სახელი ',
  'wh.tree.13': 'მაგ: სმარტ საათები...',
  'wh.tree.14': 'მშობელი კატეგორია',
  'wh.tree.15': '★ მთავარი კატეგორია',
  'wh.tree.16': 'კატეგორიის წაშლა',
  'wh.tree.17': 'ნამდვილად გსურთ ამ კატეგორიის წაშლა? წაშლა შესაძლებელია მხოლოდ მაშინ თუ ის ცარიელია პროდუქტებისგან.',
  'wh.labels.1': 'კოდი მიენიჭა — ეტიკეტი არჩეულია',
  'wh.labels.2': '{p1} პროდუქტს მიენიჭა კოდი — ეტიკეტები არჩეულია',
  'wh.labels.3': '{p1} პროდუქტს კოდი ვერ მიენიჭა — სცადე თავიდან',
  'wh.labels.4': 'აირჩიე მინიმუმ ერთი პროდუქტი',
  'wh.labels.5': 'ეტიკეტების ბეჭდვა',
  'wh.labels.6': 'არჩეულია {totalLabels} ეტიკეტი',
  'wh.labels.7': 'აირჩიე პროდუქცია და რაოდენობა',
  'wh.labels.8': 'A4 სტიკერი (63×38)',
  'wh.labels.9': 'თერმო რულონი (58×40)',
  'wh.labels.10': 'ფასის ჩვენება',
  'wh.labels.11': 'ძებნა...',
  'wh.labels.12': ' პროდუქტს შტრიხკოდი არ აქვს',
  'wh.labels.13': 'მიანიჭე მაღაზიის კოდი — ეტიკეტიდან სკანერი წაიკითხავს',
  'wh.labels.14': 'მიანიჭე კოდი (',
  'wh.labels.15': 'პროდუქტები ვერ მოიძებნა',
  'wh.labels.16': 'შტრიხკოდის გარეშე',
  'wh.labels.17': 'ენიჭება…',
  'wh.labels.18': 'მიანიჭე კოდი',
  'wh.labels.19': 'ერთით ნაკლები',
  'wh.labels.20': 'ერთით მეტი',
  'wh.labels.21': 'კიდევ ',
  'wh.labels.22': ' — მოძებნე სახელით ან შტრიხკოდით',
  'wh.labels.23': 'A4 ფურცელზე ~21 ეტიკეტი ეტევა',
  'wh.labels.24': 'თითო ეტიკეტი ცალკე ლეიბლზე იბეჭდება',
  'wh.labels.25': ' ბეჭდვა (',
  'wh.convert.1': 'რა იშლება',
  'wh.convert.3': 'მარაგი ',
  'wh.convert.4': 'აირჩიე პროდუქტი...',
  'wh.convert.5': 'დაშლა / გადაკეთება',
  'wh.convert.11': 'ვერაფერი მოიძებნა',
  'wh.convert.12': 'რამდენი იშლება',
  'wh.convert.18': 'შენიშვნა (არასავალდებულო)',
  'wh.convert.19': 'დაშლა',
  'wh.convert.20': ' ბოლო დაშლები',
  'wh.convert.21': '— დააჭირე გასამეორებლად',
  'wh.convert.22': 'იგივე დაშლის გამეორება',
  'wh.convert.23': 'პროდუქტი აღარ არსებობს',
  'wh.convert.24': '/ც',
  'wh.bd.intro': 'ერთი პროდუქტი — ერთ ან რამდენიმე ნაწილად: ტუში რბილობად და ნეკნად, ნაკრები ცალ თეფშებად, ბანკა ულუფებად. ',
  'wh.bd.introStrong': 'თვითღირებულება ნაწილებზე გასაყიდი ფასით ნაწილდება',
  'wh.bd.introEnd': ' — ასე ყოველი ნაწილი თავის ნამდვილ მოგებას აჩვენებს.',
  'wh.bd.parts': 'ნაწილები',
  'wh.bd.addPart': 'ნაწილი',
  'wh.bd.pickSource': 'რა იშლება — ტუში, ნაკრები, ბანკა?',
  'wh.bd.pickPart': 'რომელი პროდუქტი გამოდის?',
  'wh.bd.qty': 'რაოდენობა',
  'wh.bd.remove': 'ამოშლა',
  'wh.bd.price': 'ფასი',
  'wh.bd.total': '₾{total} ნაწილდება ნაწილებზე გასაყიდი ფასის მიხედვით',
  'wh.bd.totalQty': '₾{total} ნაწილდება რაოდენობის მიხედვით — ნაწილებს ფასი არ აქვთ',
  'wh.bd.yield': '{source} {unit} → {parts} {unit} ნაწილი · {pct}% · {waste} {unit} ნარჩენი',
  'wh.bd.lastYield': 'წინა ჯერზე: {source} {unit} → {parts} {unit} ({pct}%)',
  'wh.bd.lastParts': 'ნაწილები წინა დაშლიდანაა — ჩაწერე რაოდენობები',
  'wh.bd.hint.zero': '{name}: ფასი ₾0 — თვითღირებულება არ მიეწერება',
  'wh.bd.hint.allZero': 'ნაწილებს ფასი არ აქვთ — ღირებულება რაოდენობით გაიყოფა',
  'wh.bd.hint.over': '{name}: თვითღირებულება ფასს უტოლდება ან აჭარბებს',
  'wh.bd.p.stock': 'მარაგშია მხოლოდ {n} {unit}',
  'wh.bd.p.exceeds': 'ნაწილები ({parts} {unit}) წყაროზე ({source} {unit}) მეტია',
  'wh.bd.p.pieces': 'ცალობითი პროდუქტი მხოლოდ მთელი რიცხვით',
  'wh.bd.p.qty': 'რაოდენობა ნულზე მეტი უნდა იყოს, მაქსიმუმ 3 ათწილადით',
  'wh.bd.p.price': 'ერთ-ერთ პროდუქტს უარყოფითი ფასი აქვს — ჯერ ფასი გაასწორე',
  'wh.bd.p.service': 'მომსახურებას მარაგი არ აქვს — ის ვერც დაიშლება და ვერც ნაწილი იქნება',
  'wh.bd.p.unpicked': 'ყველა ნაწილს აირჩიე პროდუქტი',
  'wh.bd.offline': 'დაშლა ინტერნეტის გარეშე არ ინახება — კავშირი რომ აღდგება, შეინახე.',
  'wh.bd.histParts': '{n} ნაწილი',
  'wh.templates.1': 'კატეგორიები უკვე გაქვს · ელექტრო სასწორი ჩაირთო',
  'wh.templates.2': 'ეს კატეგორიები უკვე გაქვს',
  'wh.templates.3': ' თარო · ',
  'wh.templates.4': ' ქვეკატეგორია',
  'wh.templates.5': ' ახალი',
  'wh.templates.6': ' ჩაირთვება ელექტრო სასწორი (წონითი ეტიკეტები)',
  'wh.templates.7': 'დაამატე {fresh} კატეგორია',
  'wh.templates.8': 'შექმენი {fresh} კატეგორია',
  'wh.templates.9': 'რაც უკვე გაქვს, არ განმეორდება',
  'wh.templates.10': 'მერე გადაარქმევ, წაშლი ან დაამატებ',
  'wh.templates.11': '{parents} თარო · {children} ქვეკატ.',
  'wh.templates.12': 'ჩემით შევქმნი',
  'wh.templates.13': 'ცარიელი საწყობი — კატეგორიებს „+"-ით დაამატებ',
  'wh.templates.14': 'რა ტიპის მაღაზიაა?',
  'wh.templates.15': 'აირჩიე — მარჯვნივ ნახავ, რა თაროები შეიქმნება; ერთი ღილაკით შეიქმნება ყველა. მერე თავისუფლად შეცვლი.',
  'wh.templates.16': 'შაბლონი',
  'wh.writeoff.1': 'მიუთითე რაოდენობა',
  'wh.writeoff.2': 'ნაშთზე მეტს ვერ ჩამოწერ',
  'wh.writeoff.3': 'ჩამოიწერა {n} × {name} — ₾{cost} ხარჯში',
  'wh.writeoff.4': 'ჩამოიწერა {n} × {name}',
  'wh.writeoff.5': 'ჩამოწერა',
  'wh.writeoff.6': ' · ნაშთი ',
  'wh.writeoff.7': ' · ფილიალი „',
  'wh.writeoff.8': 'რაოდენობა',
  'wh.writeoff.9': 'ნაშთშია მხოლოდ ',
  'wh.writeoff.10': 'მიზეზი',
  'wh.writeoff.11': 'კომენტარი — არასავალდებულო',
  'wh.writeoff.12': 'მაგ. ყუთი ჩამოვარდა',
  'wh.writeoff.13': 'ხარჯში ჩაიწერება',
  'wh.writeoff.14': '{n} × ₾{purchase_price} თვითღირებულებით · ',
  'wh.writeoff.15': 'მოგებას დააკლდება, რადგან ეს საქონელი ვერ გაიყიდება',
  'wh.writeoff.16': ' ჩამოწერა',
  'wh.transfer.1': '{name} — წყარო ფილიალში მარაგი არ არის',
  'wh.transfer.2': 'აირჩიე საიდან და სად',
  'wh.transfer.3': 'ერთი და იგივე ფილიალი ვერ იქნება',
  'wh.transfer.4': 'დაამატე მინიმუმ ერთი პროდუქტი',
  'wh.transfer.5': ' მარაგის გადატანა ფილიალებს შორის',
  'wh.transfer.6': 'საიდან',
  'wh.transfer.7': 'სად',
  'wh.transfer.8': 'პროდუქტის ძებნა (სახელი / შტრიხკოდი)',
  'wh.transfer.9': 'შენიშვნა (არასავალდებულო)',
  'wh.transfer.10': ' გადააქვს...',
  'wh.transfer.11': ' გადატანა',
  'wh.transfer.12': ' ბოლო გადატანები',
  'wh.newsub.1': 'ქვეკატეგორია „{n}" დაემატა',
  'wh.newsub.2': 'ახალი — მაგ. უნისექსი',
  'wh.newsub.3': 'ახალი ქვეკატეგორიის სახელი',
  'wh.newsub.4': 'ქვეკატეგორიის დამატება',
  'wh.x.addedNext': 'დაემატა: {name} — {coded}დაასკანერე შემდეგი',
  'wh.x.codeGiven': 'კოდი მიენიჭა · ',
  'wh.x.photoOptFail': 'ფოტოს ოპტიმიზაცია ვერ მოხერხდა',
  'wh.x.modelAdded': '„{name}" — დაემატა {sizes} ზომა · {units} ცალი',
  'wh.x.modelCreated': '„{name}" — შეიქმნა {sizes} ზომა · {units} ცალი',
  'wh.x.countApplied': '{n} პროდუქტი · მარაგი გასწორდა',
  'wh.x.countReportOnly': '{n} პროდუქტი · მხოლოდ ანგარიში',
  'wh.x.renamed': 'იგივე შტრიხკოდი სხვა სახელით: {list}{more} — ',
  'wh.x.andMore': ' და კიდევ {n}',
  'wh.x.promoOff': 'გამორთული',
  'wh.x.promoLive': 'მოქმედი',
  'wh.x.promoSoon': 'დაიწყება',
  'wh.x.promoEnded': 'დასრულდა',
  'wh.x.promoPriceMissing': '{name}-ს აქციის ფასი ჩაწერე',
  'wh.x.productStem': 'პროდუქტ',
  'wh.x.catExists': '„{name}" უკვე არსებობს',
  'wh.x.catExistsHere': '„{name}" უკვე არსებობს ამ კატეგორიაში',
  'wh.x.templateApplied': '„{name}" — {n} კატეგორია შეიქმნა{scale}',
  'wh.x.scaleOn': ' · ელექტრო სასწორი ჩაირთო',
  'wh.x.woBroken': 'გატეხილი / დაზიანებული',
  'wh.x.woExpired': 'ვადაგასული',
  'wh.x.woLost': 'დაკარგული / მოპარული',
  'wh.x.woPersonal': 'პირადი მოხმარება',
  'wh.x.woSample': 'ნიმუში / დეგუსტაცია',
  'wh.x.countErrNotAllowed': 'ინვენტარიზაციაში თვლა მოლარისთვის გამორთულია',
  'wh.x.countErrDone': 'ეს ინვენტარიზაცია უკვე დასრულებულია',
  'wh.x.countErrGone': 'ინვენტარიზაცია ვერ მოიძებნა — ალბათ გაუქმდა',
  'wh.x.countErrSave': 'შენახვა ვერ მოხერხდა',
  'wh.x.countErrNoStorage': 'ამ ბრაუზერში თვლა ვერ შეინახება — გახსენი MartePOS ჩვეულებრივ ფანჯარაში (არა ინკოგნიტოში).',
  // SIZE_PRESETS' labels and COLOR_SUGGESTIONS, in order (i18n.test checks both)
  'wh.size.clothes': 'ტანსაცმელი',
  'wh.size.shoes': 'ფეხსაცმელი',
  'wh.size.jeans': 'ჯინსი (წელი)',
  'wh.size.kids': 'საბავშვო (სმ)',
  'wh.color.1': 'შავი',
  'wh.color.2': 'თეთრი',
  'wh.color.3': 'ნაცრისფერი',
  'wh.color.4': 'ლურჯი',
  'wh.color.5': 'მუქი ლურჯი',
  'wh.color.6': 'წითელი',
  'wh.color.7': 'მწვანე',
  'wh.color.8': 'ყვითელი',
  'wh.color.9': 'ვარდისფერი',
  'wh.color.10': 'ბეჟი',
  'wh.color.11': 'ყავისფერი',

  // 128 — warranty and IMEI / serial on the product
  'wh.product.warranty': 'გარანტია, თვე ',
  'wh.product.warrantyOpt': '— არასავალდებულო',
  'wh.product.warrantyPh': 'მაგ. 12',
  'wh.product.warrantyHint': 'ჩეკზე დაიბეჭდება, რომელ დღემდე მოქმედებს.',
  'wh.product.serial': 'IMEI / სერიული ნომერი',
  'wh.product.serialHint': 'სალარო ყოველი გაყიდული ერთეულის ნომერს მოითხოვს — ტელეფონი, ლეპტოპი, ტექნიკა.',
  'wh.list.serialBadge': 'IMEI',
  'wh.bulk.failed': 'გარანტია / IMEI ვერ განახლდა',
  'wh.bulk.tool': 'გარანტია / IMEI',
  'wh.bulk.toolShort': 'გარანტია',
  'wh.bulk.toolTitle': 'გარანტია და IMEI მთელ კატეგორიაზე ერთად',
  'wh.bulk.title': 'გარანტია და IMEI — კატეგორიით',
  'wh.bulk.hint': 'ერთად მიენიჭება კატეგორიის ყველა პროდუქტს, ქვეკატეგორიებიანად. ცალკე პროდუქტზე მერეც შეგიძლია შეცვლა.',
  'wh.bulk.category': 'კატეგორია',
  'wh.bulk.pickCategory': 'აირჩიე კატეგორია',
  'wh.bulk.count': '{n} პროდუქტი',
  'wh.bulk.months': 'გარანტია, თვე',
  'wh.bulk.monthsPh': 'არ შეიცვლება',
  'wh.bulk.monthsHint': '0 — გარანტია მოიხსნება.',
  'wh.bulk.serial': 'IMEI / სერიული ნომერი',
  'wh.bulk.keep': 'არ შეიცვლება',
  'wh.bulk.on': 'ჩართვა',
  'wh.bulk.off': 'გამორთვა',
  'wh.bulk.apply': 'მინიჭება',
  'wh.bulk.nothing': 'აირჩიე, რა შეიცვალოს.',
  'wh.bulk.done': 'განახლდა {n} პროდუქტი.',

  // 129 — a transfer's RS.GE waybill
  'wh.transfer.done': 'გადატანა დასრულდა',
  'wh.transfer.doneHint': 'საქონელი გადავიდა ფილიალში „{to}". მაღაზიებს შორის გადაზიდვას RS.GE-ზე შიდა ზედნადები სჭირდება.',
  'wh.transfer.waybill': 'RS.GE ზედნადები',
  'wh.transfer.waybillShort': 'ზედნადები',
  'wh.transfer.another': 'კიდევ ერთი გადატანა',
  // 1.29 — the simpler phone stocktake
  'wh.st.openRow': 'ინვენტარიზაცია მიმდინარეობს — გაგრძელება',
  'wh.st.whoLater': 'ამას მოგვიანებით თანამშრომლების გვერდზე შეცვლი',
  'wh.st.continue': 'გაგრძელება',
  'wh.st.startTitle': 'რას ითვლი?',
  'wh.st.startNote1': 'დაუთვლელი პროდუქტის მარაგი არ შეიცვლება.',
  'wh.st.startNote2': 'თუ პროდუქტი თაროზე არ არის, ჩაწერე 0.',
  'wh.st.startNoteSplit': 'მოლარეც ითვლის — გაინაწილეთ თაროები.',
  'wh.st.startButton': 'თვლის დაწყება',
  'wh.st.history': 'წინა თვლები',
  'wh.st.title': 'დათვლა',
  'wh.st.progress': 'დათვლილია {done} / {all} · {scope}',
  'wh.st.seeResult': 'შედეგის ნახვა',
  'wh.st.iFinished': 'დავასრულე',
  'wh.st.tabLeft': 'დასათვლელია · {n}',
  'wh.st.tabDone': 'დათვლილია · {n}',
  'wh.st.hint': 'დაასკანერე პროდუქტი ან შეეხე სიაში.',
  'wh.st.allPhones': 'ყველა ტელეფონით: {n}',
  'wh.st.otherPhoneOnly': 'სხვა ტელეფონით',
  'wh.st.otherPhoneToo': 'სხვა ტელეფონმაც დაითვალა',
  'wh.st.otherPhoneCounted': 'სხვა ტელეფონით დათვლილი',
  'wh.st.system': 'სისტემაში: {n}',
  'wh.st.howMany': 'ახლა რამდენი იპოვე?',
  'wh.st.mineSoFar': 'ამ ტელეფონით ჩაწერილია: {n}',
  'wh.st.notOnShelf': 'თაროზე არ არის — 0',
  'wh.st.add': 'დამატება',
  'wh.st.saving': 'ინახება…',
  'wh.st.changeTotal': 'ჯამის შეცვლა',
  'wh.st.mineTotal': 'ამ ტელეფონით სულ',
  'wh.st.removeMine': 'ჩემი ჩანაწერის წაშლა',
  'wh.st.saved': 'შენახულია — {name}: {n}',
  'wh.st.saveFailed': 'ვერ შეინახა — შეამოწმე ინტერნეტი და სცადე ისევ',
  'wh.st.isBarcode': 'ეს შტრიხკოდია — ჯერ დაამატე ან დახურე',
  'wh.st.enterQty': 'ჩაწერე, რამდენი იპოვე',
  'wh.st.cashierDoneTitle': 'შენი თვლა შენახულია',
  'wh.st.cashierDoneText': 'უთხარი მფლობელს, რომ დაასრულე.',
  'wh.st.confirmTitle': 'თვლა დასრულდა?',
  'wh.st.confirmUncounted': '{n} პროდუქტი არავის დაუთვლია — მათი მარაგი არ შეიცვლება.',
  'wh.st.confirmOthers': 'სხვა ტელეფონითაც ითვლიდნენ — დარწმუნდი, რომ მათაც დაასრულეს.',
  'wh.st.confirmYes': 'კი, შედეგის ნახვა',
  'wh.st.resultTitle': 'შედეგი',
  'wh.st.short': 'დაკლებულია {n} პროდუქტი — ₾{v}',
  'wh.st.surplus': 'მეტია {n} — ₾{v}',
  'wh.st.matching': '{n} ემთხვევა',
  'wh.st.uncounted': '{n} არ დაგითვლიათ — არ შეიცვლება',
  'wh.st.diffLine': 'სისტემაში {e} · დაითვალეთ {c}',
  'wh.st.apply': 'ნაპოვნი სხვაობა მარაგშიც ჩავწეროთ',
  'wh.st.saveFailedFor': 'ვერ შეინახა — {name}. გახსენი და სცადე ისევ.',
  'wh.st.unsaved': 'ვერ შეინახა: {names} — გახსენი და სცადე ისევ, მერე დაასრულე.',
  'wh.st.resultChanged': 'სხვა ტელეფონმა ახლახან დაამატა — შედეგი განახლდა. გადახედე და დააჭირე ისევ.',
  'wh.st.reportOnly': 'მარაგი არ შეიცვალოს — მხოლოდ შედეგი შეინახება',
  'wh.st.doneApplied': 'დასრულდა — ნაპოვნი სხვაობა მარაგშიც ჩაიწერა.',
  'wh.st.doneReport': 'დასრულდა — შედეგი შენახულია, მარაგი არ შეცვლილა.',
  // 1.34 — receive a model's box by its table
  'wh.rcv.action': 'მიღება',
  'wh.rcv.actionFor': 'მიღება — „{name}"',
  'wh.rcv.actionDetail': 'ახალი ყუთი ცხრილით',
  'wh.rcv.title': 'მიღება — {name}',
  'wh.rcv.sub': 'ჩაწერე, რამდენი მოვიდა თითო ფერსა და ზომაზე.',
  'wh.rcv.branch': 'ნაშთი დაემატება ფილიალს „{name}".',
  'wh.rcv.supplier': 'მომწოდებელი',
  'wh.rcv.noSupplier': 'მომწოდებლის გარეშე',
  'wh.rcv.supplierHint': 'არჩევითია. თუ სრულად არ გადაიხდი, დარჩენილი თანხა ამ მომწოდებელს გვმართებს.',
  'wh.rcv.cost': 'საყიდელი ფასი, 1 ც.',
  'wh.rcv.costUp': 'თვითღირებულება ₾{from} → ₾{to} · მარჟა ₾{sale}-ზე: {pct}%',
  'wh.rcv.costNow': 'ახლანდელი თვითღირებულება ₾{cost} · ამ ფასით მარჟა: {pct}%',
  'wh.rcv.paid': 'გადახდილი',
  'wh.rcv.paidPh': 'სრულად',
  'wh.rcv.paidHint': 'ცარიელი — სრულად გადახდილი',
  'wh.rcv.scan': 'სკანერი ჩართულია — ყუთის კოდის დასკანერება თავის უჯრას 1-ს უმატებს',
  'wh.rcv.fillAll': 'ყველა უჯრაში:',
  'wh.rcv.fillBtn': 'ჩაწერა',
  'wh.rcv.legendStock': 'ნაცრისფერი რიცხვი — ახლა თაროზეა',
  'wh.rcv.legendNew': '„ახალი" — ეს ფერი × ზომა ჯერ არ გაქვთ, შენახვისას შეიქმნება',
  'wh.rcv.isNew': 'ახალი',
  'wh.rcv.rowSupplier': 'მომწოდებლის კოდი',
  'wh.rcv.rowLabel': 'ეტიკეტი დაიბეჭდება',
  'wh.rcv.cellAria': '{p1} — რამდენი მოვიდა',
  'wh.rcv.addPrompt': 'ყუთში ახალი ზომა ან ფერია?',
  'wh.rcv.addSize': 'ზომა',
  'wh.rcv.addColor': 'ფერი',
  'wh.rcv.addSizeAria': 'ზომის დამატება',
  'wh.rcv.addColorAria': 'ფერის დამატება',
  'wh.rcv.addHint': 'ახალს მაღაზიის კოდი (29…) მიეცემა და ეტიკეტი დაებეჭდება.',
  'wh.rcv.sumUnits': 'მოვიდა {units} ც. · ₾{total}',
  'wh.rcv.sumDebt': 'მომწოდებლის ვალი: ₾{debt}',
  'wh.rcv.sumDebtWe': ' (ჩვენ გვმართებს)',
  'wh.rcv.sumLabels': 'ეტიკეტი: {n} ცალი',
  'wh.rcv.sumNoLabels': 'ეტიკეტი არ სჭირდება — მოსულ ზომებს მომწოდებლის კოდი აქვს',
  'wh.rcv.save': 'მიღება',
  'wh.rcv.saveLabels': 'მიღება და ეტიკეტები',
  'wh.rcv.errCost': 'ჩაწერე საყიდელი ფასი (0 ან მეტი)',
  'wh.rcv.errEmpty': 'არცერთ უჯრაში რაოდენობა არ წერია',
  'wh.rcv.errWhole': 'რაოდენობა — მთელი რიცხვი 1-დან 9 999-მდე',
  'wh.rcv.errPaid': 'გადახდილი თანხა არასწორია',
  'wh.rcv.errPaidOver': 'გადახდილი ჯამზე (₾{total}) მეტია',
  'wh.rcv.otherProduct': '„{name}" — სხვა საქონელია',
  'wh.rcv.unknownCode': 'კოდი ვერ მოიძებნა: {code}',
  'wh.rcv.done': '„{name}": მიღებულია {units} ც. · ₾{total}',
  'wh.rcv.madeNotReceived': 'ახალი ზომები შეიქმნა ({n}), მაგრამ მიღება ვერ ჩაიწერა — დააჭირე ისევ',
  'wh.rcv.mismatch': 'ზოგი უჯრა ვერ მოიძებნა — დახურე და ხელახლა გახსენი ფანჯარა',
  'wh.rcv.busyScan': 'ინახება — ეს ყუთი დაასკანერე ხელახლა',
  'wh.rcv.gone': 'ეს მოდელი წაიშალა',
  'wh.fit.label': 'ერგება',
  'wh.fit.make': 'მარკა',
  'wh.fit.model': 'მოდელი',
  'wh.fit.makePh': 'მარკა (Opel)',
  'wh.fit.modelPh': 'მოდელი (Astra H)',
  'wh.fit.makePhPhone': 'მარკა (Apple)',
  'wh.fit.modelPhPhone': 'მოდელი (iPhone 15 Pro)',
  'wh.fit.from': 'წლიდან',
  'wh.fit.to': 'წლამდე',
  'wh.fit.note': 'შენიშვნა (წინა, 1.6)',
  'wh.fit.add': 'დამატება',
  'wh.fit.remove': 'ჩანაწერის წაშლა',
  'wh.fit.yearsHint': 'წელი არ არის აუცილებელი — ცარიელი ნიშნავს: ყველა წელი / არ ვიცი. სალარო ასეთ ნაწილს „შეამოწმე"-თი აჩვენებს.',
  'wh.fit.err.make': 'ჩაწერე მარკა (40 ასომდე)',
  'wh.fit.err.model': 'ჩაწერე მოდელი (60 ასომდე)',
  'wh.fit.err.years': 'წლები: 1950–2100, „წლიდან" არ უნდა აღემატებოდეს „წლამდე"-ს',
  'wh.fit.err.note': 'შენიშვნა 60 ასომდე და წელს არ უნდა ჰგავდეს',
  'wh.fit.err.chars': 'მძიმე, წერტილ-მძიმე და ფრჩხილები არ შეიძლება',
  'wh.fit.err.tooMany': 'ერთ პროდუქტზე მაქსიმუმ 40 ჩანაწერი',
  'wh.fit.err.dup': 'ეს ჩანაწერი ორჯერაა',
  'wh.fit.analogs': 'ანალოგები',
  'wh.fit.saveFailed': 'პროდუქტი შეინახა, „ერგება" და OEM ნომრები — ვერა: {why}',
  'wh.fit.offline': 'ინტერნეტი არ არის',
  'wh.fit.refused': 'ბაზამ არ მიიღო — გადაამოწმე ჩანაწერები',
  'wh.oem.label': 'OEM / შემცვლელი ნომრები',
  'wh.oem.placeholder': 'მაგ. 93176358',
  'wh.oem.add': 'დამატება',
  'wh.oem.remove': 'წაშლა {code}',
  'wh.oem.hint': 'ორიგინალის ნომერი და სხვა ბრენდების შემცვლელი ნომრები. ერთი ნომრის მქონე პროდუქტები ერთმანეთის ანალოგებია.',
  'wh.oem.err.chars': '/ , ; ნომერში არ შეიძლება',
  'wh.oem.err.long': 'ნომერი 40 სიმბოლომდე',
  'wh.oem.err.dup': 'ეს ნომერი ორჯერაა',
  'wh.oem.err.tooMany': 'ერთ პროდუქტზე მაქსიმუმ 20 ნომერი',
  'wh.import.stage.fit': '„ერგება" და OEM ნომრები...',
  'wh.import.fitDone': '„ერგება" / OEM ნომრები დაემატა {n} პროდუქტს',
  'wh.import.fitFailed': '„ერგება" / OEM ნომრები ვერ ჩაიწერა Excel-ის სტრიქონებისთვის {from}–{to} ({why})',
  'wh.import.fitOwner': 'ამას მხოლოდ მფლობელი ცვლის',
  'wh.import.fitBad': '„ერგება" / OEM — {n} ჩანაწერი ვერ წავიკითხე, დანარჩენი შემოვიდა: {list}{more}',
  'wh.import.why.fit': 'სტრიქონი {row}: „{entry}"',
  'wh.import.fitFailedOpening': 'საწყისი ნაშთი ჩაიწერა ({total} სტრიქონი), მაგრამ {fail}. ატვირთე იგივე ფაილი ხელახლა — ნაშთი არ გაორმაგდება, „ერგება" კი დაემატება.',
  'wh.import.fitFailedReceive': 'ჩაიწერა: {parts}. მაგრამ {fail}. ხელახლა ატვირთვამდე „რაოდენობის" სვეტი გაასუფთავე — თორემ ნაშთი მეორედ დაემატება; „ერგება" დაემატება და არ გაორმაგდება.',
  'wh.import.fitCap': 'ფაილი არ აიტვირთა: ერთ პროდუქტზე მაქსიმუმ 40 „ერგება" და 20 OEM ნომერია — {list}{more}. შეამცირე და ატვირთე ხელახლა.',
  'wh.import.fitCapRow': '„{name}" (სტრიქონი {row})',
  'wh.codes.label': 'დამატებითი შტრიხკოდები',
  'wh.codes.placeholder': 'დაასკანერე ან ჩაწერე კოდი',
  'wh.codes.add': 'დამატება',
  'wh.codes.remove': 'წაშლა: {code}',
  'wh.codes.hint': 'სალარო, ინვენტარიზაცია და ზედნადები პროდუქტს ამ კოდებითაც იპოვის. ეტიკეტზე მთავარი კოდი იბეჭდება.',
  'wh.codes.taken': 'კოდი {code} უკვე აქვს: {name}',
  'wh.codes.tooMany': 'მაქსიმუმ 10 დამატებითი კოდი',
  'wh.codes.tooLong': 'კოდი ძალიან გრძელია (მაქს. 64 სიმბოლო)',
  'wh.codes.badChars': 'კოდში არ შეიძლება იყოს / , ; და ის არ შეიძლება იყოს „PLU 24"-ის სახის — ასეთებს Excel კოდებად ყოფს',
  // 169 — a service: sold at the till, never stock
  'wh.svc.switch': 'მომსახურება — მარაგი არ ითვლება',
  'wh.svc.hint': 'ასლი, ბეჭდვა, შუშის დაკვრა, დაჭრა, მიტანა ან ადგილზე მომზადებული სასმელი: სალარო ყიდის ნებისმიერი რაოდენობით, ინვენტარიზაციაში და საწყობის ღირებულებაში არ ჩანს.',
  'wh.svc.cost': 'თვითღირებულება (არასავალდებულო)',
  'wh.svc.errStock': 'ჯერ ჩამოწერე ან გაყიდე ნაშთი — მარაგიანი პროდუქტი მომსახურებად ვერ იქცევა.',
  'wh.svc.badge': 'მომსახურება',
} as const
